module.exports = __webpack_public_path__ + "img/Play.c6b93134.svg";